<!--
 * @Description: 现金宝充值
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-04-30 15:32:31
 * @LastEditors: luoshoufeng@szkingdom.com
-->
<template>
    <div v-if="xjbFundFileFlag">
        <comp-title-dc back-url-name="moneybox" :back-url-query="{ activeIndex: 1 }">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/moneyBox' }">大成钱柜</el-breadcrumb-item>
                <el-breadcrumb-item>充值</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div class="bizcomp-money-in">
            <el-form
                ref="fundInfo"
                :rules="rules"
                :model="fundInfo"
                label-width="409px"
                v-on:submit.native.prevent
            >
                <el-form-item label="钱柜总资产：" prop="availableMoney">
                    <div class="available-money-box">
                        <div>
                            <span class="available-money">
                                {{ $util.fmtNum(fundInfo.availableMoney) }}
                            </span>
                            元
                        </div>
                    </div>
                </el-form-item>
                <el-form-item
                    label="扣款账号："
                    prop="pay"
                    style="position: relative"
                    class="payway-list"
                >
                    <el-select v-model="fundInfo.pay" placeholder="请选择扣款账号"></el-select>
                    <div
                        v-if="dialogBankLists.length > 0"
                        class="hot-area"
                        v-on:click="selectBank"
                    ></div>
                    <span
                        class="add-bank-btn"
                        v-on:click.prevent="
                            $router.push({
                                name: 'addbank'
                            })
                        "
                    >
                        新增银行卡
                    </span>
                </el-form-item>
                <el-form-item label="存入金额：" prop="amount">
                    <el-input
                        v-model.trim="fundInfo.amount"
                        class="prefix"
                        :placeholder="pla"
                        :maxlength="14"
                    />
                </el-form-item>
                <el-form-item v-if="Number(fundInfo.amount)" label="确认金额：">
                    {{ $util.capitalRMB(fundInfo.amount) }}
                </el-form-item>
                <el-form-item v-if="isPwdCheck" label="交易密码：" prop="pwd">
                    <el-input
                        v-model.trim="fundInfo.pwd"
                        type="password"
                        placeholder="请输入交易密码"
                        :maxlength="16"
                    />
                    <!--                    <span-->
                    <!--                        class="redemp-btn margin-l-10"-->
                    <!--                        v-on:click.prevent="$router.push({ name: 'tradepwd' })"-->
                    <!--                    >-->
                    <!--                        <span class="like-a">忘记密码？</span>-->
                    <!--                    </span>-->
                </el-form-item>
                <el-form-item style="margin-left: -80px">
                    <div
                        v-if="readFileInfoList.length !== 0 || xjbFundFile.length !== 0"
                        class="check-box bar-pad showChenckbox"
                        style="
                            font-size: 14px;
                            display: flex;
                            align-items: flex-start;
                            padding-left: -10px;
                        "
                    >
                        <ul>
                            <li
                                v-for="(item, index) in readFileInfoList"
                                :key="index"
                                class="flex hcenter"
                            >
                                <el-checkbox
                                    v-model="checkboxs[index].checkbox"
                                    size="mini"
                                    text-color="red"
                                    v-on:change="handleCheck(index)"
                                ></el-checkbox>
                                <div>
                                    <span class="ml4 c_999">同意</span>
                                    <a
                                        class="file-content"
                                        target="_blank"
                                        v-on:click="getClick1(index)"
                                    >
                                        《{{ item.filename }}》
                                    </a>
                                </div>
                            </li>
                            <li
                                v-for="(item, index) in xjbFundFile"
                                :key="readFileInfoList.length + index"
                                class="flex hcenter"
                            >
                                <el-checkbox
                                    v-model="checkboxs[readFileInfoList.length + index].checkbox"
                                    size="mini"
                                    text-color="red"
                                ></el-checkbox>
                                <div>
                                    <span class="ml4 c_999">同意</span>
                                    <a
                                        v-if="item.fileid"
                                        class="file-content"
                                        target="_blank"
                                        v-on:click="getClick2(index)"
                                    >
                                        《{{ item.title }}》
                                    </a>
                                    <span v-else class="file-content" v-on:click="argRead(item)">
                                        《{{ item.title }}》
                                    </span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </el-form-item>
                <el-form-item>
                    <div style="margin-top: 20px">
                        <el-button class="back-btn" v-on:click="backFn">返回重选</el-button>
                        <el-button
                            :class="
                                'confirm-btn ' +
                                (disabeldFlag || isOpen ? 'disable-btn' : 'active-btn')
                            "
                            :disabled="disabeldFlag || isOpen"
                            :loading="isOpen"
                            v-on:click="submitInfo()"
                        >
                            确定
                        </el-button>
                    </div>
                </el-form-item>
            </el-form>
            <select-bank
                :dialog-bank-lists="dialogBankLists"
                :select-bank-show="selectBankShow"
                v-on:select-bank-close="selectBankClose"
                v-on:select-bank-info="selectBankInfo"
            ></select-bank>
            <el-dialog
                title="充值结果"
                :visible.sync="resultDialog"
                class="prop info-tips"
                width="700px"
                :before-close="resultDialogClose"
            >
                <div>
                    <div class="success-res">
                        <div>
                            <img src="../../assets/img/buy_success.png" alt="" />
                        </div>
                        <div class="success-text">您好，充值成功！</div>
                    </div>
                    <div class="btn-box">
                        <button class="btn-confirm" v-on:click="resultDialogClose">确定</button>
                    </div>
                </div>
            </el-dialog>
            <pdf-popup
                base64
                :visible="pdfVisible"
                :need-time="needTime"
                :read-file-info-list="currentFileInfoList"
                v-on:close="pdfVisible = false"
            ></pdf-popup>
            <my-dialog
                :title="agrData.title"
                :visible.sync="agrVisible"
                :dialog-close="agrVisibleHide"
                width="800px"
            >
                <div class="protocol-detail" v-html="agrData.content"></div>
                <div class="align-c">
                    <el-button type="primary" style="width: 180px" v-on:click="agrVisible = false">
                        确定
                    </el-button>
                </div>
            </my-dialog>
            <fund-protocol v-model="protocol" :fund="protocolFund" v-on:all-read="generalBuy" />
        </div>
        <footer-questions :warning-html="warningHtml"></footer-questions>
    </div>
</template>
<script>
import selectBank from "@/components/layout/selectBank.vue";
import userApi from "@/api/user";
import mixin from "@/assets/js/mixin";
import PdfPopup from "@/components/util/pdfPopup";
import fundApi from "@/api/fund";
import myDialog from "@/components/layout/myDialog.vue";
import fundProtocol from "@/components/form/fundProtocol";
import footerQuestions from "@/components/layout/footerQuestions.vue";

export default {
    name: "MoneyIn",
    components: { selectBank, PdfPopup, myDialog, fundProtocol, footerQuestions },
    mixins: [mixin],
    data() {
        return {
            fund: {},
            fundcode: "",
            xjbFundFile: [],
            xjbFundFileFlag: false,
            readFileInfoList: [], // 披露文件信息
            currentFileInfoList: [], // 当前阅读信批文件
            checkboxs: [],
            pdfVisible: false,
            protocol: false,
            protocolFund: {},
            needTime: false,
            agrVisible: false,
            agrData: {},
            pla: "请输入存入金额",
            isOpen: false,
            fundInfo: {
                pay: "",
                amount: "",
                availableMoney: "0",
                pwd: ""
            },
            isPwdCheck: false,
            resultDialog: false,
            selectBankShow: false,
            dialogBankLists: [],
            bankInfo: {},
            limit: { text: "存入金额范围为：", min: "0", max: "0" }, // 限额
            rules: {
                // 校验规则配置
                pay: [
                    {
                        required: true,
                        message: "请选择支付方式",
                        trigger: "change"
                    }
                ],
                amount: [
                    {
                        validator: this.amountLimit,
                        mes: "投资金额",
                        trigger: "change"
                    }
                ],
                pwd: [
                    {
                        required: true,
                        message: "请输入交易密码",
                        trigger: "blur"
                    }
                ]
            },
            warningHtml:
                "“自动存入”指的是定期定额申购大成添利宝E(000726)， “自动取出“指的是定期定额赎回大成添利宝E(000726)。"
        };
    },
    computed: {
        disabeldFlag() {
            if (this.checkboxs.length == 0) {
                return false;
            }
            for (let i = 0; i < this.checkboxs.length; i++) {
                if (!this.checkboxs[i].checkbox) {
                    return true;
                }
            }
            return false;
        }
    },
    mounted() {
        this.isPwdCheck = this.$cache.getPwdCheck("022");
        this.getAssetsInfo();
        this.queryXjbFundInfo();
    },
    methods: {
        handleCheck(index) {
            this.currentFileInfoList = [this.readFileInfoList[index]];
            if (this.currentFileInfoList[0].filetype === "1") {
                if (this.checkboxs[0].checkbox) {
                    this.needTime = true;
                    this.pdfVisible = true;
                }
            }
        },
        // 查询现金宝信息
        async queryXjbFundInfo() {
            const res = await fundApi.cfgFundrealtimeQueryAll();
            this.fundcode = res.data && res.data[0] && res.data[0].fundcode;
            if (!this.fundcode) {
                this.$message({
                    type: "warning",
                    message: "未配置现金宝信息！"
                });
                return false;
            }
            const fundRes = await fundApi.getFundLists({
                fundcode: this.fundcode,
                pagesize: 10,
                pagenum: 1
            });
            if (fundRes.data) {
                this.fund = fundRes.data.list[0];
                this.getFileInfo();
                this.getBuyWay();
            }
        },
        // 购买前查询
        async getBuyWay() {
            this.dialogBankLists = [];
            const res = await fundApi.qryBeforeBuy({
                fundcode: this.fund.fundcode,
                sharetype: this.fund.sharetype
            });
            if (res.data && res.data.returnList3) {
                res.data.returnList3.forEach((item) => {
                    if (item.paycenterid != "0001" && item.paycenterid != "1000") {
                        this.dialogBankLists.push(item);
                    }
                });
            }
            // this.dialogBankLists = res.data.returnList3;
            const reqRes = await userApi.getMyBankCards();
            if (reqRes.data.data) {
                this.dialogBankLists.forEach((item) => {
                    reqRes.data.data.forEach((reqItem) => {
                        if (reqItem.paycenterid + reqItem.bankcode == item.channelid) {
                            item.perdaymax = reqItem.perdaymax;
                            item.maxlimitsingle = reqItem.maxlimitsingle;
                        }
                    });
                });
            }
        },
        // 获取披露文件信息
        async getFileInfo() {
            this.$util.queryReadFileInfo(
                {
                    fundcode: this.fund.fundcode,
                    sharetype: this.fund.sharetype,
                    filetype: ""
                },
                (res) => {
                    res.forEach((item) => {
                        item.read = false;
                        this.checkboxs.push({ checkbox: false });
                        if (item.filetype.trim() === "1") {
                            // 产品概要
                            this.readFileInfoList.unshift(item);
                        } else {
                            this.readFileInfoList.push(item);
                        }
                    });
                    this.fund.proto = "xjbBuy";
                    this.$util.getSdxProtocol(this.fund, (res) => {
                        this.fund = res;
                        this.protocolFund = JSON.parse(JSON.stringify(res));
                        this.protocolFund.protoArr = [];
                        if (res.protoArr && res.protoArr.length > 0) {
                            res.protoArr.forEach((item) => {
                                item.filename = item.title;
                                if (item.fileid == null || !item.fileid) {
                                    item.fileid = "";
                                }
                                this.xjbFundFile.push(item);
                                this.checkboxs.push({ checkbox: false });
                            });
                        }
                        this.xjbFundFileFlag = true;
                    });
                }
            );
        },
        // 获取链接点击事件
        getClick1(index) {
            this.currentFileInfoList = [this.readFileInfoList[index]];
            this.readFileInfoList[index].read = true;
            if (this.currentFileInfoList[0].filetype === "1") {
                this.needTime = true;
            } else {
                this.needTime = false;
            }
            this.pdfVisible = true;
        },
        getClick2(index) {
            this.currentFileInfoList = [this.xjbFundFile[index]];
            this.needTime = false;
            this.pdfVisible = true;
        },
        backFn() {
            this.$router.push({
                name: "moneybox",
                query: { activeIndex: "1" }
            });
        },
        submitInfo() {
            this.$refs["fundInfo"].validate((valid) => {
                if (valid) {
                    // 获取留痕申请编号
                    this.$util.writeFileInfo(
                        {
                            readFileInfoList: this.readFileInfoList,
                            fundcode: this.fund.fundcode,
                            tano: this.fund.tano
                        },
                        (res) => {
                            this.readappno = res;
                            if (this.readFileInfoList.length > 0 && this.readappno.length === 0) {
                                return this.$alert("没有留痕申请编号,操作失败 请联系客服");
                            }
                            this.protocol = true;
                        }
                    );
                } else {
                    this.$errorScroll();
                }
            });
        },
        generalBuy(val) {
            this.protocol = false;
            if (!val) return;
            if (this.readFileInfoList.length > 0 && this.readappno.length === 0) {
                return this.$alert("没有留痕申请编号,操作失败 请联系客服");
            }
            let data = {
                transactionaccountid: this.bankInfo.transactionaccountid,
                tradepassword: this.$util.enc(this.fundInfo.pwd),
                paychannel: this.bankInfo.paycenterid,
                applicationamount: this.fundInfo.amount,
                readappno: this.readappno
            };
            // 下单
            this.planOpen(data);
        },
        async planOpen(params) {
            this.isOpen = true;
            try {
                const res = await fundApi.combTransRealtaBuy(params);
                if (res.data) {
                    this.getAssetsInfo();
                    this.resultDialog = true;
                }
            } catch (e) {
                this.$log.error(e);
            } finally {
                this.isOpen = false;
            }
        },
        // 处理限额
        amountLimit(rule, value, callback) {
            this.$util.validateAmountLimit(this, rule, value, callback);
        },
        checkDebitdate(rule, value, callback) {
            if (value.trim() === "" && value.trim() !== "5") {
                callback(new Error("请选择扣款日期"));
            } else {
                callback();
            }
        },
        selectBank() {
            this.selectBankShow = true;
        },
        selectBankClose(value) {
            this.selectBankShow = false;
        },
        selectBankInfo(bankInfo) {
            this.bankInfo = bankInfo;
            this.fundInfo.pay =
                this.bankInfo.paycentername +
                "-" +
                this.$cache.getDict("110080", this.bankInfo.bankcode) +
                "(**" +
                this.bankInfo.depositcard.slice(-4) +
                ")";
            this.$set(
                this.limit,
                "min",
                this.bankInfo.netnominbuy ? this.bankInfo.netnominbuy : "0"
            );
            this.$set(this.limit, "max", this.bankInfo.netnomaxbuy);
            this.pla =
                this.$util.fmtNum(this.limit.min) +
                "元起，最多可充值" +
                this.$util.fmtNum(this.limit.max) +
                "元";
        },

        agrVisibleHide() {
            this.agrVisible = false;
        },
        argRead(item) {
            this.agrVisible = true;
            this.agrData = item;
        },
        // 查现金宝资产
        async getAssetsInfo() {
            const res = await fundApi.getHoldingAssets({});
            if (res.data && res.data.first) {
                this.fundInfo.availableMoney = res.data.first.xjbasset;
            }
        },
        resultDialogClose() {
            this.resultDialog = false;
            this.$router.push({ name: "moneybox" });
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";
.bizcomp-money-in {
    width: 1200px;
    background: #ffffff;
    box-sizing: border-box;
    border: 1px solid #f1f1f1;
    margin-top: 13px;
    padding-top: 40px;
    margin-bottom: 20px;
    .payway-list {
        position: relative;
        .hot-area {
            width: 400px;
            height: 40px;
            // background-color: #1890ff;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 99 !important;
            cursor: pointer;
        }
        .add-bank-btn {
            position: absolute;
            left: 410px;
            font-size: 14px;
            font-weight: normal;
            color: #1890ff;
            cursor: pointer;
        }
    }
    .available-money-box {
        display: flex;
        align-items: center;
        .available-money {
            font-size: 22px;
            font-weight: normal;
            color: #e60012;
            vertical-align: top;
        }
    }
    .back-btn {
        width: 180px;
        height: 42px;
        border-radius: 2px;
        background: #e4e4e4;
        font-size: 16px;
        font-weight: 500;
        text-align: center;
        color: #666666;
        border: none;
        cursor: pointer;
    }
    .confirm-btn {
        width: 180px;
        height: 42px;
        border-radius: 2px;
        font-size: 16px;
        font-weight: 500;
        text-align: center;
        color: #ffffff;
        border: none;
        margin-left: 40px;
    }
    .active-btn {
        background: #e60012;
        cursor: pointer;
    }
    .disable-btn {
        background: #f7b2b8;
    }
    .success-res {
        margin: 40px 0 30px;
        width: 660px;
        height: 242px;
        border-radius: 6px;
        background: #f9f9f9;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .success-text {
            font-size: 26px;
            font-weight: 500;
            margin-top: 23.85px;
            color: #333333;
        }
    }
    .btn-box {
        text-align: center;
        padding-bottom: 56px;
        .btn-confirm {
            width: 180px;
            text-align: center;
            height: 42px;
            line-height: 42px;
            border-radius: 2px;
            background: #e60012;
            color: #ffffff;
            border: none;
            cursor: pointer;
        }
    }
    .file-content {
        text-decoration: none;
        color: #e60012;
        cursor: pointer;
    }
    .protocol-detail {
        padding: 20px 10px;
        max-height: 80vh;
        min-height: 10vh;
        overflow: scroll;
    }
    .el-input,
    .el-select {
        width: 400px;
    }
    .el-input__inner {
        font-size: 22px !important;
        font-weight: normal;
        color: #333333;
    }
    .margin-l-10 {
        margin-left: 10px;
    }
    :deep(.el-form-item__label) {
        padding: 0;
        font-size: 14px;
        font-weight: normal;
        color: #333333;
    }
    :deep(.el-form-item__label:before) {
        display: none;
    }
}
</style>
